// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1306":"83a1e86e","6948":"42935301","7267":"d531f78f","8630":"030554e0"}[chunkId] + ".chunk.css";
};